const ENGLISH_ONLY_PRIVATE_SEGMENTS = ['my', 'sys', 'account', 'welcome', 'leaderboard', 'share'];

export function isEnglishOnlyPrivatePath(href: string): boolean {
  if (!href.startsWith('/')) {
    return false;
  }
  const firstSegment = href.split('/')[1]?.split(/[?#]/)[0];
  return firstSegment ? ENGLISH_ONLY_PRIVATE_SEGMENTS.includes(firstSegment) : false;
}
